module.exports = __webpack_public_path__ + "static/media/postgresql.d07949e8.svg";